window.IdentityDocumentForm = function ($scope, document, Upload, brand, brandServices, hUser, isCandidate, jobId) {
    var self = this;
    var formName = "identity-document-form";
    var _protected = BaseForm.call(self, formName, $scope);
    var _emitter = JarEventEmitter.call(self);

    var modalUploadSelector = "#uploadDocsModal";

    self.data = {};
    document = document || {};
    self.hasInstructions = true;
    self.brandId = brand.id;
    self.data.brand_name = brand.name;
    self.userId = hUser.data.user.id;
    self.jobId = jobId;
    self.link_to_trustid = null;
    self.doc_code = OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT
    self.brand = brand;
    self.rtwRemoteCheckingEnabled = false;
    self.isShowWarningMsg = false;
    self.COUNTRY_TYPES = RightToWorkAPI.COUNTRY_TYPES;

    const MAX_NUM_OF_OTHER_ATTACHEMENT = 10;

    self.change = function () {
        var shareCodeData = {};
        if (self.share_code_option === self.identityOptions.SHARE_CODE) {
            shareCodeData.share_code = self.data.share_code
            shareCodeData.birth_date = self.data.birth_date && moment(self.data.birth_date).isValid() && moment(self.data.birth_date).format('YYYY-MM-DD')
        }
        _emitter.trigger("change", self.data.candidate_signed, shareCodeData);
    };

    self.identityOptions = {
        'SHARE_CODE': 'SHARE_CODE',
        'PASSPORT': 'PASSPORT',
        'LIST_A': 'LIST_A',
        'LIST_B1': 'LIST_B1',
        'LIST_B2': 'LIST_B2',
    };

    self.load = function (formData) {

        var defer = $q.defer();
        self.loading = true;

        self.shareCodeFlag = false;
        self.mainOptionsFlag = true;
        self.LastSectionFlag = true;
        self.OthersFlag = false;
        self.rtwRemoteCheckingSection = false;

        self.isCandidate = isCandidate;
        self.source = formData?.source;

        if (hUser.isEmployer() && !isCandidate) {
            brandServices.checkAll(brand.id, [brandServices.SERVICES.RIGHT_TO_WORK, brandServices.SERVICES.TRUST_ID_FULL])
                .then(function(services) {
                    if (services[brandServices.SERVICES.RIGHT_TO_WORK]) {
                        RightToWorkAPI.getRightToWorkSettings(brand.id)
                            .then(function (res) {
                                self.countryType = res['country_type'];
                                defer.resolve({code: "META_LOADED"});
                            })
                            .catch(function (err) {
                                console.error(err);
                                defer.reject();
                            })
                            .finally(function () {
                                self.loading = false;
                                $scope.$digest();
                            });
                    } else if (services[brandServices.SERVICES.TRUST_ID_FULL]) {
                        EVerifyAPI.getBrandTrustIdSettings(self.brandId, brandServices.SERVICES.TRUST_ID_FULL)
                            .then((res) => {
                            self.countryType = res.country_code;
                            defer.resolve({code: "META_LOADED"});
                            self.loading = false;
                            self.syncScope();
                        })
                    } else {
                        console.error('Something went wrong!');
                        defer.reject();
                        self.loading = false;
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                    self.loading = false;
                });
        } else {
            EVerifyAPI.getBrandTrustIdSettings(self.brandId, brandServices.SERVICES.TRUST_ID_FULL)
                .then((res) => {
                    if (Object.keys(res).length) {
                        self.countryType = res.country_code;
                        self.rtwRemoteCheckingEnabled = res['remote_checking_enabled'];
                        self.isHideOthersOptionEnabled = res['remote_checking_hide_others_option'];
                    } else {
                        self.countryType = RightToWorkAPI.COUNTRY_TYPES.UK;
                    }
                }
            ).catch(function (err) {
                console.error('Something went wrong!', err);
                defer.reject();
            }).finally(function () {
                defer.resolve({code: "META_LOADED"});
                self.loading = false;
                self.syncScope();
            });

        }

        return defer.promise;
    };

    delete self.data.candidate_signed;

    self.selectedFiles = {};
    self.uploadFormAttachments = {};
    var other_attachements = [];
    var files = [];
    self.upload = {
        'doc_list_GENERIC_OPTIONAL': 'VISA',
        'doc_list_SHARE_CODE_DOCUMENTS': 'student_terms',
    };

    self.hide_preview = true;

    var uplodes = {
        "SHARE_CODE_DOCUMENTS": {
            "student_terms": {
                attachments: [
                    {
                        title: "A document confirming the student’s term time and vacation dates (optional)",
                        custom_title: "e.g. A printout from the student’s education institution",
                        code: "SHARE_CODE_STUDENT_TERM_TIME_VACATION_DATES_CONFIRMING_DOCUMENT",
                        mandatory: false,
                        list: 'SHARE_CODE_DOCUMENTS'
                    },
                    {
                        title: "Other supporting documents (optional)",
                        custom_title: "",
                        code: "SHARE_CODE_OTHER",
                        mandatory: false,
                        list: 'SHARE_CODE_DOCUMENTS'
                    }
                ]
            }

        },
        "PASSPORT": {
            "passport_or_national_identity_card": {
                documents: [
                    { code: "european_passport", title: "Passport", list: "PASSPORT" },
                    { code: "european_national_identity_card", title: "Passport Card", list: "PASSPORT" }
                ]
            },
            "european_passport": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show: Clear Photo/ Passport Number/ Date of Issue/ Date of Expiration/ Signature",
                        code: "LIST_A_EUROPEAN_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_EUROPEAN_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "european_national_identity_card": {
                attachments: [
                    {
                        title: "Front of Card",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_EEA_ID_CARD_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Card",
                        custom_title: "Please upload a clear copy of the back of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_EEA_ID_CARD_BACK",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_EEA_ID_CARD_OTHER",
                        mandatory: false
                    }
                ]
            },
            "passport": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show:  Clear Photo/ Passport Number/ Date of Issue/ Date of Expiration/ Signature",
                        code: "LIST_A_BRITISH_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_BRITISH_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            }
        },
        "A": {
            "passport": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show: » Clear Photo » Passport Number » Date of Issue » Date of Expiration » Signature",
                        code: "LIST_A_BRITISH_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_BRITISH_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "european_passport": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show: » Clear Photo » Passport Number » Date of Issue » Date of Expiration » Signature",
                        code: "LIST_A_EUROPEAN_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_EUROPEAN_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "european_national_identity_card": {
                attachments: [
                    {
                        title: "Front of Card",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_EEA_ID_CARD_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Card",
                        custom_title: "Please upload a clear copy of the back of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_EEA_ID_CARD_BACK",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_EEA_ID_CARD_OTHER",
                        mandatory: false
                    }
                ]
            },
            "passport_or_national_identity_card": {
                documents: [
                    { code: "european_passport", title: "Passport", list: "A" },
                    { code: "european_national_identity_card", title: "Passport Card", list: "A" }
                ]
            },
            "registration_certificate": {
                attachments: [
                    {
                        title: "A current document indicating the holder is permitted to stay indefinitely",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Home Office to a family member of a national of a European Economic Area country or Switzerland, ensuring edges have not been cut off.",
                        code: "LIST_A_REGISTRATION_CERTIFICATE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_REGISTRATION_CERTIFICATE_OTHER",
                        mandatory: false
                    }
                ]
            },
            "permanent_residence": {
                attachments: [
                    {
                        title: "A document indicating the holder is permitted to stay indefinitely ",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Bailiwick of Jersey, the Bailiwick of Guernsey or the Isle of Man, which has been verified as valid by the Home Office Employer Checking Service, showing that the holder has been granted unlimited leave to enter or remain.",
                        code: "LIST_A_PERMANENT_RESIDENCE_CARD_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "Verification Letter issued by the Employer Checking Service (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off. ",
                        code: "LIST_A_PERMANENT_RESIDENCE_CARD_VERIFICATION",
                        mandatory: hUser.isEmployer()? true : false
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_PERMANENT_RESIDENCE_CARD_OTHER",
                        mandatory: false
                    }
                ]
            },
            "biometric_immigration": {
                attachments: [
                    {
                        title: "Front of Document",
                        custom_title: "Please upload a clear copy of the front of your current Biometric Immigration document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIOMETRIC_RESIDENCE_PERMIT_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Document",
                        custom_title: "Please upload a clear copy of the back of your current Biometric Immigration document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIOMETRIC_RESIDENCE_PERMIT_BACK",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_BIOMETRIC_RESIDENCE_PERMIT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "passport_endorsed": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show: » Clear Photo » Passport Number » Date of Issue » Date of Expiration » Signature",
                        code: "LIST_A_CURRENT_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Endorsed Page on Passport",
                        custom_title: "Please ensure you upload the page that shows that the holder is allowed to stay in the UK and is currently allowed to do the type of work in question.",
                        code: "LIST_A_ENDORSED_PAGE_ON_PASSPORT",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page within your passport containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_CURRENT_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "immigration_status_document": {
                attachments: [
                    {
                        title: "A Current Immigration Status Document",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_IMMIGRATION_STATUS_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "An official document giving the person’s permanent National Insurance number and their name issued by a Government agency or a previous employer.",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_IMMIGRATION_STATUS_DOCUMENT_NATIONAL_INSURANCE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_IMMIGRATION_STATUS_DOCUMENT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "adoption_certificate": {
                attachments: [
                    {
                        title: "A Birth or Adoption Certificate Document",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_UK",
                        mandatory: true
                    },
                    {
                        title: "An official document giving the person’s permanent National Insurance number and their name issued by a Government agency or a previous employer.",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_UK_NATIONAL_INSURANCE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_UK_OTHER",
                        mandatory: false
                    }
                ]
            },
            "adoption_certificate_channel_islands": {
                attachments: [
                    {
                        title: "A Birth or Adoption Certificate Document",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_IRELAND",
                        mandatory: true
                    },
                    {
                        title: "An official document giving the person’s permanent National Insurance number and their name issued by a Government agency or a previous employer.",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_IRELAND_NATIONAL_INSURANCE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_BIRTH_OR_ADOPTION_CERTIFICATE_IRELAND_OTHER",
                        mandatory: false
                    }
                ]
            },
            "certificate_of_registration": {
                attachments: [
                    {
                        title: "A Certificate of Registration or Naturalisation as a British Citizen",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_NATURALISATION_CERTIFICATE",
                        mandatory: true
                    },
                    {
                        title: "An official document giving the person’s permanent National Insurance number and their name issued by a Government agency or a previous employer.",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_A_NATURALISATION_CERTIFICATE_NATIONAL_INSURANCE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_A_NATURALISATION_CERTIFICATE_OTHER",
                        mandatory: false
                    }
                ]
            },
        },
        "B": {
            "passport_list_b": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a <b>current</b> clear copy of your passport and it must show: » Clear Photo » Passport Number » Date of Issue » Date of Expiration » Signature",
                        code: "LIST_B_CURRENT_PASSPORT_PHOTO_PAGE",
                        mandatory: true
                    },
                    {
                        title: "Endorsed Page on Passport",
                        custom_title: "Please ensure you upload the page that shows that the holder is allowed to stay in the UK and is currently allowed to do the type of work in question.",
                        code: "LIST_B_ENDORSED_PAGE_ON_PASSPORT",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any page within your passport containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_CURRENT_PASSPORT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "biometric_immigration_list_b": {
                attachments: [
                    {
                        title: "Front of Document",
                        custom_title: "Please upload a clear copy of the front of your current Biometric Immigration document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_BIOMETRIC_IMMIGRATION_DOCUMENT_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Document",
                        custom_title: "Please upload a clear copy of the back of your current Biometric Immigration document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_BIOMETRIC_IMMIGRATION_DOCUMENT_BACK",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "If you are a student and your Biometric Residence Permit states this, then you are required to upload evidence of term dates (as opposed to overall course dates).",
                        code: "LIST_B_BIOMETRIC_IMMIGRATION_DOCUMENT_OTHER",
                        mandatory: false
                    }
                ]
            },
            "residence_card_list_b": {
                attachments: [
                    {
                        title: "A current document indicating the holder is permitted to stay for a time limited period",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Home Office to a national of a European Economic Area country or Switzerland, ensuring edges have not been cut off.",
                        code: "LIST_B_RESIDENCE_CARD_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_RESIDENCE_CARD_OTHER",
                        mandatory: false
                    }
                ]
            },
            "baliwick_rule_2008_list_b": {
                attachments: [
                    {
                        title: "A current document indicating the holder has been granted limited leave to enter or remain",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Bailiwick of Jersey, the Bailiwick of Guernsey or the Isle of Man, which has been verified as valid by the Home Office Employer Checking Service, showing that the holder has been granted limited leave to enter or remain",
                        code: "LIST_B_BALIWICK_RULE_2008_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_BALIWICK_RULE_2008_OTHER",
                        mandatory: false
                    }
                ]
            },
            "baliwick_rule_before_june_21_list_b": {
                attachments: [
                    {
                        title: "A document indicating the holder has made an application for leave to enter or remain",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Bailiwick of Jersey, the Bailiwick of Guernsey which has been verified as valid by the Home Office Employer Checking Service, showing that the holder has made an application for leave to enter or remain.",
                        code: "LIST_B_BALIWICK_RULE_BEFORE_JUNE_21_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "Verification Letter issued by the Employer Checking Service (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_BALIWICK_RULE_BEFORE_JUNE_21_VERIFICATION",
                        mandatory: hUser.isEmployer()? true : false
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_BALIWICK_RULE_BEFORE_JUNE_21_OTHER",
                        mandatory: false
                    }
                ]
            },
            "frontier_permit_2020_list_b": {
                attachments: [
                    {
                        title: "Front of Frontier Worker Permit",
                        custom_title: "Please upload a clear copy of the front of your Frontier Worker Permit document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_FRONTIER_PERMIT_2020_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Frontier Worker Permit",
                        custom_title: "Please upload a clear copy of the back of your Frontier Worker Permit document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_FRONTIER_PERMIT_2020_BACK",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_FRONTIER_PERMIT_2020_OTHER",
                        mandatory: false
                    }
                ]
            },
            "immigration_status_list_b": {
                attachments: [
                    {
                        title: "A Current Immigration Status Document",
                        custom_title: "Please upload a clear copy of your current Immigration Status Document containing a photograph issued by the Home Office to the holder in full, ensuring edges have not been cut off.",
                        code: "LIST_B_IMMIGRATION_STATUS_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "An official document giving the person’s permanent National Insurance number and their name issued by a Government agency or a previous employer.",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_B_IMMIGRATION_STATUS_DOCUMENT_NATIONAL_INSURANCE",
                        mandatory: true
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_B_IMMIGRATION_STATUS_DOCUMENT_OTHER",
                        mandatory: false
                    }
                ]
            },
        },
        "C": {
            "certificate_of_application_list_c": {
                attachments: [
                    {
                        title: "A document indicating the holder has made an application for leave to enter or remain",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Home Office to the holder, ensuring edges have not been cut off.",
                        code: "LIST_C_APPLICATION_CERTIFICATE",
                        mandatory: true
                    },
                    {
                        title: "Positive Verification Notice (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_C_APPLICATION_CERTIFICATE_POSITIVE_VERIFICATION_NOTICE",
                        mandatory: hUser.isEmployer()? true : false
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_C_APPLICATION_CERTIFICATE_OTHER",
                        mandatory: false
                    }
                ]
            },
            "jersey_immigration_rules": {
                attachments: [
                    {
                        title: "A document indicating the holder has made an application for leave to enter or remain",
                        custom_title: "Please upload a clear copy of the certificate/document in full that has been issued by the Bailiwick of Jersey, the Bailiwick of Guernsey which has been verified as valid by the Home Office Employer Checking Service, showing that the holder has made an application for leave to enter or remain.",
                        code: "LIST_C_JERSEY_IMMIGRATION_RULES_DOCUMENT",
                        mandatory: true
                    },
                    {
                        title: "Positive Verification Notice (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_C_JERSEY_IMMIGRATION_RULES_POSITIVE_VERIFICATION_NOTICE",
                        mandatory: hUser.isEmployer()? true : false
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_C_JERSEY_IMMIGRATION_RULES_OTHER",
                        mandatory: false
                    }
                ]
            },
            "application_registration_list_c": {
                attachments: [
                    {
                        title: "Front of Card",
                        custom_title: "Please upload a clear copy of the front of your Application Registration Card in full, ensuring edges have not been cut off.",
                        code: "LIST_C_APPLICATION_REGISTRATION_CARD_FRONT",
                        mandatory: true
                    },
                    {
                        title: "Back of Card",
                        custom_title: "Please upload a clear copy of the back of your Application Registration card in full, ensuring edges have not been cut off.",
                        code: "LIST_C_APPLICATION_REGISTRATION_CARD_BACK",
                        mandatory: true
                    },
                    {
                        title: "Positive Verification Notice (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_C_APPLICATION_REGISTRATION_CARD_POSITIVE_VERIFICATION_NOTICE",
                        mandatory: !!hUser.isEmployer()
                    }
                ]
            },
            "positive_verification_notice_list_c": {
                attachments: [
                    {
                        title: "Positive Verification Notice (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_C_POSITIVE_VERIFICATION_NOTICE",
                        mandatory: !!hUser.isEmployer()
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_C_POSITIVE_VERIFICATION_NOTICE_OTHER",
                        mandatory: false
                    }
                ]
            },
            "certificate_of_applications_list_c": {
                attachments: [
                    {
                        title: "A document indicating the holder has made an application for leave to enter or remain",
                        custom_title: "Please upload a clear copy of the Certificate of Application in full that has been issued by the Home Office, showing that the holder has made an application for leave to enter or remain.",
                        code: "LIST_C_CERTIFICATE_OF_APPLICATION",
                        mandatory: !!hUser.isEmployer()
                    },
                    {
                        title: "Positive Verification Notice (optional for applicant but must be uploaded by the employer)",
                        custom_title: "Please upload a clear copy of the document in full, ensuring edges have not been cut off.",
                        code: "LIST_C_CERTIFICATE_OF_APPLICATION_POSITIVE_VERIFICATION_NOTICE",
                        mandatory: !!hUser.isEmployer()
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        custom_title: "For example, any supporting document containing information indicating the holder has an entitlement to enter or remain in the UK and undertake the work in question.",
                        code: "LIST_C_CERTIFICATE_OF_APPLICATION_OTHER",
                        mandatory: false
                    }
                ]
            },
        },
        "GENERIC_REQUIRED": {
            "passport": {
                attachments: [
                    {
                        title: "Photo Page",
                        custom_title: "Please ensure you upload a clear copy and it must show: » Clear Photo » Passport Number » Date of Issue » Date of Expiration » Signature",
                        code: "GENERIC_RTW_PASSPORT",
                        mandatory: true,
                        list: 'GENERIC_REQUIRED'
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        code: "GENERIC_RTW_PASSPORT_OTHER",
                        mandatory: false,
                        list: 'GENERIC_REQUIRED'
                    }
                ]
            },
            "ID_CARD": {
                attachments: [
                    {
                        title: "Front of Card",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        code: "GENERIC_RTW_ID_CARD_FRONT",
                        mandatory: true,
                        list: 'GENERIC_REQUIRED'
                    },
                    {
                        title: "Back of Card",
                        custom_title: "Please upload a clear copy of the back of the document in full, ensuring edges have not been cut off.",
                        code: "GENERIC_RTW_ID_CARD_BACK",
                        mandatory: true,
                        list: 'GENERIC_REQUIRED'
                    },
                    {
                        title: "Other supporting evidence (optional)",
                        code: "GENERIC_RTW_ID_CARD_OTHER",
                        mandatory: false,
                        list: 'GENERIC_REQUIRED'
                    }
                ]
            },
        },
        "GENERIC_OPTIONAL": {
            "VISA": {
                attachments: [
                    {
                        code: "GENERIC_RTW_VISA_FRONT",
                        title: "Front of Card",
                        custom_title: "Please upload a clear copy of the front of the document in full, ensuring edges have not been cut off.",
                        mandatory: true,
                        list: 'GENERIC_OPTIONAL'
                    },
                    {
                        code: "GENERIC_RTW_VISA_BACK",
                        title: "Back of Card",
                        custom_title: "Please upload a clear copy of the back of the document in full, ensuring edges have not been cut off.",
                        mandatory: true,
                        list: 'GENERIC_OPTIONAL'
                    },
                    {
                        code: "GENERIC_RTW_VISA",
                        title: "Other supporting evidence (optional)",
                        mandatory: false,
                        list: 'GENERIC_OPTIONAL'
                    },
                ]
            }
        },
    };

    self.mappingCustomName = {
        passport: "Passport",
        european_passport: "EEA Passport/ID Card",
        european_national_identity_card: "EEA Passport/ID Card",
        registration_certificate: "A current document indicating the holder is permitted to stay indefinitely",
        permanent_residence: "A document indicating indefinite leave to remain. The employer must also upload a Verification Letter from the EVS",
        biometric_immigration: "Biometric residence permit (stay proof)",
        passport_endorsed: "Passport with Stay Proof",
        immigration_status_document: "Immigration status document with national insurance",
        adoption_certificate: "UK birth/adoption certificate with national insurance document",
        adoption_certificate_channel_islands: "Channel Islands/Isle of Man/Ireland birth/adoption certificate with national insurance document",
        certificate_of_registration: "Registration/Naturalisation Certificate with national insurance document",
        passport_list_b: "Stay Endorsed Passport",
        biometric_immigration_list_b: "Biometric residence permit (work authorisation)",
        residence_card_list_b: "A current document indicating the holder is permitted to stay for a time limited period",
        immigration_status_list_b: "Immigration status document with work endorsement and national insurance",
        baliwick_rule_2008_list_b: "A current document indicating the holder is permitted to stay for a time limited period",
        baliwick_rule_before_june_21_list_b: "A document indicating an application has been made to leave to remain. The employer must also upload a Verification Letter from the EVS",
        frontier_permit_2020_list_b: "Frontier Permit 2020",
        certificate_of_application_list_c: "A document indicating an application has been made to leave to remain. The employer must also upload a Verification Letter from the EVS",
        application_registration_list_c: "An Application Registration Card. The employer must also upload a Verification Letter from the EVS",
        jersey_immigration_rules: "A document indicating an application has been made to leave to remain. The employer must also upload a Verification Letter from the EVS",
        positive_verification_notice_list_c: "Positive verification notice",
        certificate_of_applications_list_c: "A document indicating the holder has made an application for leave to enter or remain. The employer must also upload a Verification Letter from the EVS",
        ID_CARD: "National Identity Card",
        VISA: "Visa",
        student_terms: "Supporting Documents"

    };

    self.ROI_IDENTITY_DOC_CODES = [
        { code: 'ROI_BIRTH_ADOPT_UK', label: 'Birth or Adoption Certificate from UK, Channel Islands or Isle of Man' },
        { code: 'ROI_PPS_CARD', label: 'Card showing PPS (Personal Public Service) Number (2 sided)' },
        { code: 'ROI_BRIT_NAT_CERT', label: 'Certificate of Naturalisation as a British Citizen' },
        { code: 'ROI_REG_CERT', label: 'Certificate of Registration' },
        { code: 'ROI_GNIB_LETTER', label: 'GNIB Letter' },
        { code: 'ROI_ID_CARD', label: 'ID Card' },
        { code: 'ROI_ID_CARD_EEA', label: 'ID Card (EEA or Swiss Only)' },
        { code: 'ROI_ISD_LETTER', label: 'Immigration Service Delivery Letter' },
        { code: 'ROI_INIS_LETTER', label: 'INIS Letter' },
        { code: 'ROI_IRISH_BIRTH_CERT', label: 'Irish Birth Certificate' },
        { code: 'ROI_IRISH_ADOPT_CERT', label: 'Irish Certificate of Adoption' },
        { code: 'ROI_IRISH_NAT_CERT', label: 'Irish Certificate of Naturalisation' },
        { code: 'ROI_IRP_CARD', label: 'Irish Residence Permit' },
        { code: 'ROI_LABOUR_MARKET_ACCESS_PERMISSION', label: 'Labour Market Access Permission' },
        { code: 'ROI_PPS_LETTER', label: 'Letter showing PPS (Personal Public Service) Number' },
        { code: 'ROI_PASSPORT', label: 'Passport' },
        { code: 'ROI_PASSPORT_STAMP', label: 'Passport Stamp' },
        { code: 'ROI_TEMP_PROTECT_LETTER', label: 'Temporary Protection Letter' },
        { code: 'ROI_TEMP_RES_CARD', label: 'Temporary Residence Card' },
        { code: 'ROI_WORK_PERMIT', label: 'Work Permit' },
        { code: 'ROI_WH_AUTH', label: 'Working Holiday Authorisation' },
        { code: 'ROI_NAME_CHANGE_DOC', label: 'Change of Name' }
    ];

    self.onROIDocChanged = () => {
        self.selectedFiles['ROI'] = null;
    }

    self.onOptionChange = function(option) {
        var defer = $q.defer();
        switch (option) {
            case self.identityOptions.SHARE_CODE:
                self.share_code_option = self.identityOptions.SHARE_CODE;
                self.upload['doc_list_PASSPORT'] = null;
                self.upload['doc_list_A'] = null;
                self.upload['doc_list_B'] = null;
                self.upload['doc_list_C'] = null;
                if (!hUser.isEmployer() && isCandidate) {
                    if (self.rtwRemoteCheckingEnabled) {
                        self.rtwRemoteCheckingSection = true;
                        self.adjustFlags();
                    }
                }
                if (!self.rtwRemoteCheckingEnabled) {
                    self.shareCodeFlag = true;
                    self.LastSectionFlag = true;
                    self.mainOptionsFlag = false;
                    self.syncScope();
                }
                break;
            case self.identityOptions.PASSPORT:
                self['share_code_option'] = null;
                self.upload['doc_list_A'] = null;
                self.upload['doc_list_B'] = null;
                self.upload['doc_list_C'] = null;
                break;
            case self.identityOptions.LIST_A:
                self['share_code_option'] = null;
                self.upload['doc_list_PASSPORT'] = null;
                self.upload['doc_list_B'] = null;
                self.upload['doc_list_C'] = null;
                break;
            case self.identityOptions.LIST_B1:
                self['share_code_option'] = null;
                self.upload['doc_list_PASSPORT'] = null;
                self.upload['doc_list_A'] = null;
                self.upload['doc_list_C'] = null;
                break;
            case self.identityOptions.LIST_B2:
                self['share_code_option'] = null;
                self.upload['doc_list_PASSPORT'] = null;
                self.upload['doc_list_A'] = null;
                self.upload['doc_list_B'] = null;
                break;
        }
        self.change();
    };

    self.onFileSelected = function (files, list, docsInside) {
        self.isShowWarningMsg = false;
        if (docsInside.includes('_OTHER') && other_attachements.length === MAX_NUM_OF_OTHER_ATTACHEMENT) {
            self.isShowWarningMsg = true;
            return;
        }
        if (files && files[0]) {

            var fileType = Utils.getFileType(files[0]);

            if ((fileType.indexOf("image/") > -1 && fileType.indexOf("image/gif") == -1) || fileType.indexOf("/pdf") > -1) {
                self.selectedFiles[list] = self.selectedFiles[list] || {};
                
                if (docsInside.includes('_OTHER') ) {
                    self.selectedFiles[list][docsInside] = self.selectedFiles[list][docsInside] || {};
                    files[0]["progress"] = 100;
                    other_attachements.push(files[0]);
                    self.selectedFiles[list][docsInside].other_attachements = other_attachements;
                } else {
                    self.selectedFiles[list][docsInside] = files[0];
                    self.selectedFiles[list][docsInside]["progress"] = 100;
                }
                if (list == 'A') {
                    self.upload['doc_list_C'] = null;
                    self.upload['doc_list_B'] = null;
                } else {
                    self.upload['doc_list_A'] = null;
                }
                self.allFiles = true;

                self.validateFiles();
            }
            else {
                hAlert("Invalid Attachment", "Attachment document should be image or PDF file.");
            }
        }
    };

    self.unselectFile = function (listId, docInside, index) {
        if (docInside) {
            if (self.selectedFiles[listId][docInside].other_attachements && self.selectedFiles[listId][docInside].other_attachements.length > 1) {
                self.selectedFiles[listId][docInside].other_attachements.splice(index, 1);
            } else {
                delete self.selectedFiles[listId][docInside];
                other_attachements = [];
            }
        } else {
            self.selectedFiles[listId] = null;
        }

        self.validateFiles();
    };
    self.checkShareCodeDoc  = function (){
        if (self.upload.doc_list_SHARE_CODE_DOCUMENTS && self.selectedFiles['SHARE_CODE_DOCUMENTS']) {
            return true ;
        }
        else return false;
    }
    var generateAttachementFiles = function (list, docInside, codeLookup) {
        var docList;
        var selectedFile = self.selectedFiles[list][docInside];
        var isOtherAttachment = docInside.includes('_OTHER');

        if (list === 'A') {
            docList = self.upload.doc_list_A;
        } else if (list === 'B') {
            docList = self.upload.doc_list_B;
        } else if (list === 'C') {
            docList = self.upload.doc_list_C;
        } else if (list === 'PASSPORT') {
            docList = self.upload.doc_list_PASSPORT;
        } else if (list === 'SHARE_CODE_DOCUMENTS') {
            docList = self.upload.doc_list_SHARE_CODE_DOCUMENTS;
        }

        if (!isOtherAttachment) {
            files.push({
                list: list,
                name: self.mappingCustomName[docList],
                code: codeLookup,
                file: selectedFile
            });
        } else {
            var otherAttachments = selectedFile.other_attachements;
            for (var j = 0; j < otherAttachments.length; j++) {
                files.push({
                    list: list,
                    name: self.mappingCustomName[docList],
                    code: codeLookup,
                    file: otherAttachments[j]
                });
            }
        }
    }

    self.getFiles = function () {
        var defer = $q.defer();
        OnBoardingAPI.getAttachmentCodeLookup()
            .then(function (attachmentCodeLookup) {
                files = [];
                if (self.upload.doc_list_SHARE_CODE_DOCUMENTS && self.selectedFiles['SHARE_CODE_DOCUMENTS']) {
                    Object.keys(self.selectedFiles['SHARE_CODE_DOCUMENTS']).forEach(function (key) {
                        generateAttachementFiles('SHARE_CODE_DOCUMENTS', key, attachmentCodeLookup[key].id);
                    });
                }
                if (self.upload.doc_list_PASSPORT && self.selectedFiles['PASSPORT']) {
                    Object.keys(self.selectedFiles['PASSPORT']).forEach(function (key) {
                        generateAttachementFiles('PASSPORT', key, attachmentCodeLookup[key].id);
                    });
                }

                if (self.upload.doc_list_A && self.selectedFiles['A']) {
                    Object.keys(self.selectedFiles['A']).forEach(key => {
                        generateAttachementFiles('A', key, attachmentCodeLookup[key].id);
                    });
                }

                if (self.upload.doc_list_B && self.selectedFiles['B']) {
                    Object.keys(self.selectedFiles['B']).forEach(key => {
                        generateAttachementFiles('B', key, attachmentCodeLookup[key].id);
                    });
                }
                if (self.upload.doc_list_C && self.selectedFiles['C']) {
                    Object.keys(self.selectedFiles['C']).forEach(key => {
                        generateAttachementFiles('C', key, attachmentCodeLookup[key].id)
                    });
                }

                var listsIds = ['GENERIC_REQUIRED', 'GENERIC_OPTIONAL'];
                for (var i in listsIds) {
                    var listId = listsIds[i];
                    if (self.upload['doc_list_' + listId] && self.selectedFiles[listId]) {
                        for (var key in self.selectedFiles[listId]) {
                            var isOtherAttachment = key.includes('_OTHER');
                            if (!isOtherAttachment) {
                                var index = files.push({
                                    list: listId,
                                    name: self.mappingCustomName[self.upload['doc_list_' + listId]],
                                    file: self.selectedFiles[listId][key],
                                    code: attachmentCodeLookup[key].id,
                                }) - 1;
                                if (self.countryType === RightToWorkAPI.COUNTRY_TYPES.GENERIC) {
                                    files[index]['expiration_date'] = self.expirationDate[listId].toISOString();
                                }
                            } else {
                                var otherAttachments = self.selectedFiles[listId][key].other_attachements;
                                for (var j = 0; j < otherAttachments.length; j++) {
                                    var index = files.push({
                                        list: listId,
                                        name: self.mappingCustomName[self.upload['doc_list_' + listId]],
                                        file: otherAttachments[j],
                                        code: attachmentCodeLookup[key].id,
                                    }) - 1;
                                    if (self.countryType === RightToWorkAPI.COUNTRY_TYPES.GENERIC) {
                                        files[index]['expiration_date'] = self.expirationDate[listId].toISOString();
                                    }
                                }
                            }
                        }
                    }
                }

                if (self.countryType === RightToWorkAPI.COUNTRY_TYPES.ROI) {
                    if (self.selectedFiles['ROI'][self.data.ROIDoc]) {
                        files.push({
                            list: RightToWorkAPI.COUNTRY_TYPES.ROI,
                            file: self.selectedFiles['ROI'][self.data.ROIDoc],
                            code: attachmentCodeLookup[self.data.ROIDoc].id,
                            name: attachmentCodeLookup[self.data.ROIDoc].name
                        })
                    }
                }

                defer.resolve(files);

            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.showListAProgress = function (listId) {
        var valid = true;
        if(_.isEmpty(self.selectedFiles[listId])) {
            valid = false;
        } else if (self.selectedFiles[listId]){
            var mandatoryAttach = _.filter(self.uploadFormAttachments[listId].attachments,function(x){return x.mandatory});
            valid = _.every(mandatoryAttach, function(attachment) {return self.selectedFiles[listId][attachment.code]});
        } else {
            valid = false;
        }
        return valid;
    };

    self.showListOthersProgress = function (listId) {
        var valid = true;

        if (self.selectedFiles[listId]){
            self.uploadFormAttachments[listId].attachments.forEach(function (attachment) {
                if(attachment.mandatory){
                    if(!self.selectedFiles[listId][attachment.code]){
                        valid = false;

                    }
                }
            });
        } else {
            valid = false;
        }

        return valid;
    };

    self.clearAllListAFiles = function (listId) {
        self.allFiles = null;
        self.selectedFiles[listId] = null;
        other_attachements = [];
        self.validateFiles();
    };

    self.showUploadFor = function (listId) {
        var validListOthers = self.selectedFiles['SHARE_CODE_DOCUMENTS'];
        var validListPassport = self.selectedFiles['PASSPORT'];
        var validListA = self.selectedFiles['A'];
        var validListB = self.selectedFiles['B'];
        var validListC = self.selectedFiles['C'];
        var validLisGeneric = self.selectedFiles['GENERIC_REQUIRED'];
        var validListGenericVisa = self.selectedFiles['GENERIC_OPTIONAL'];

        if (validListOthers) {
            validListOthers = self.showListAProgress('SHARE_CODE_DOCUMENTS');
            self.student_files = true;
        }
        if (validListPassport) {
            validListOthers = self.showListAProgress('PASSPORT');
            self.allFiles = true;
        }
        if (validListA) {
            validListA = self.showListAProgress('A');
            self.allFiles = true;
        }

        if (validListB) {
            validListB = self.showListAProgress('B');
            self.allFiles = true;
        }

        if (validListC) {
            validListC = self.showListAProgress('C');
            self.allFiles = true;
        }

        if (validLisGeneric) {
            validLisGeneric = self.showListAProgress('GENERIC_REQUIRED');
            self.allFiles = true;
        }

        if (validListGenericVisa) {
            validListGenericVisa = self.showListAProgress('GENERIC_OPTIONAL');
            self.visa_files = true;
        }

        if (validListPassport || validListOthers || validListA || (validListB || validListC) || ((validLisGeneric || validListGenericVisa) && self.selectedFiles[listId])) {
            hConfirm("Your uploaded files will be removed. Are you sure you want to continue" + "?", function (confirm) {
                if (confirm) {
                    self.uploadFrom = listId;
                    self.selectedFiles[listId] = null;

                    try {
                        $scope.$digest();
                    } catch (e) {
                    }

                    $(modalUploadSelector).modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: true
                    });
                }
            });
        } else {
            self.uploadFormAttachments[listId] = uplodes[listId][self.upload['doc_list_' + listId]];
            self.uploadFrom = listId;
            $(modalUploadSelector).modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        }
    };

    self.chooseDocumentType = function (listId) {
        self.uploadFormAttachments = {};
        self.uploadFormAttachments[listId] = uplodes[listId][self.upload['doc_list_' + listId]];
    };

    self.validateFiles = function () {
        if (self.countryType === RightToWorkAPI.COUNTRY_TYPES.ROI) {
            let isFormFilled =  self.validator.validate();
            let selectedFile = self.selectedFiles['ROI'];

            return isFormFilled && selectedFile;
        }
        if (self.share_code_option === self.identityOptions.SHARE_CODE) {
            return self.validator.validate();
        }
        self.allFiles = null;

        var isFormValidate = self.validator.validate();

        var validListA = self.selectedFiles['A'];
        var validListB = self.selectedFiles['B'];
        var validListC = self.selectedFiles['C'];
        var validLisGeneric = self.selectedFiles['GENERIC_REQUIRED'];
        var validLisPassport= self.selectedFiles['PASSPORT'];


        if (validListA) {
            validListA = self.showListAProgress('A');
            self.allFiles = true;
        }

        if (validListB) {
            validListB = self.showListAProgress('B');
        }

        if (validListC) {
            validListC = self.showListAProgress('C');
            self.allFiles = true;
        }

        if (validLisGeneric) {
            validLisGeneric = self.showListAProgress('GENERIC_REQUIRED');
            self.allFiles = true;
        }
        if (validLisPassport) {
            validLisPassport = self.showListAProgress('PASSPORT');
            self.allFiles = true;
        }

        if (validLisPassport || validListA || (validListB || validListC) || validLisGeneric) {
            self.allFiles = true;
            return isFormValidate;
        }

        self.allFiles = true;
        return false;
    };

    var uploadFiles = function (file) {
        var defer = $q.defer();
        var url = publicConfiguration.OnboardingServerBaseURL + 'brands/' + brand.id + '/documents';
        url += ((document.id) ? ('/' + document.id) : '');

        Upload.upload({
            'url': url,
            'withCredentials': true,
            'headers': {},
            'method': 'POST',
            'data': file,
            'Content-Type': 'multipart/form-data',
            'arrayKey': '[]'
        }).progress(function (evt) {
            var uploaded = evt.loaded || 0;
            var total = evt.total;
            file.progress = 100 * uploaded / total;
        }).success(function (data, status, headers, config) {
            if (data.status_code == 200) {
                defer.resolve(data);
            } else {
                defer.reject(data);
            }
        }).error(function (reason) {
            defer.reject(reason);
        });

        return defer.promise;
    };

    var candidateDocAction = function (previousResults) {
        var defer = $q.defer();
        if (document.id && document.state !== OnBoardingAPI.appStatuses.SIGNED) {
            if (self.share_code_option !== self.identityOptions.SHARE_CODE) {
                delete self.data.share_code;
                delete self.data.birth_date;
            }
            var data = angular.copy(self.data);
            if (data.birth_date) {
                data.birth_date = moment(data.birth_date).format('YYYY-MM-DD');
            }
            OnBoardingAPI.candidateDocAction(document.id, OnBoardingAPI.appStatuses.SIGNED, data)
                .then(function (res) {
                        defer.resolve(res);
                    },
                    function (err) {
                        defer.reject(err);
                    });
        }
        else {
            defer.resolve(previousResults);
        }
        return defer.promise;
    };
    self.getFilesProcess  = function(saveData) {
        saveData = saveData || {};
        var defer = $q.defer();
        var promises = [];
        self.getFiles().then(function (files) {
                var requestedFiles = {};

                files.forEach(function (file) {
                    requestedFiles[file.list] = requestedFiles[file.list] || {};
                    requestedFiles[file.list].attachment_file = requestedFiles[file.list].attachment_file || [];
                    requestedFiles[file.list].attachment_code_lookup_ids = requestedFiles[file.list].attachment_code_lookup_ids || [];
                    requestedFiles[file.list].attachment_expiration_dates = requestedFiles[file.list].attachment_expiration_dates || [];

                    requestedFiles[file.list].attachment_file.push(file.file);
                    requestedFiles[file.list].attachment_code_lookup_ids.push(file.code);
                    if (file.expiration_date) {
                        requestedFiles[file.list].attachment_expiration_dates.push(file.expiration_date);
                    }

                    requestedFiles[file.list].custom_name = file.name;
                    requestedFiles[file.list].list_type = file.list;
                });

                var keys = Object.keys(requestedFiles);

                var filesToSend = [];

                keys.forEach(function (key) {
                    var file = requestedFiles[key];

                    if (file) {

                        file['document_code'] = OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT;

                        if (saveData.positionId) {
                            file['position_id'] = saveData.positionId;
                        }

                        if (saveData.userId) {
                            file['user_id'] = saveData.userId;
                        }

                        if (saveData.jobId) {
                            file['job_id'] = saveData.jobId;
                        }

                        if (saveData.applicationId) {
                            file['application_id'] = saveData.applicationId;
                        }

                        if (saveData.prospectId) {
                            file['prospect_id'] = saveData.prospectId;
                        }

                        filesToSend.push(file);
                    }
                });

                uploadFiles(filesToSend[0])
                    .then(function (res) {
                        if (res && res.data && (res.data.document || res.data.attachments)) {
                            var check = false;
                            if (_.isEmpty(document)) {
                                check = true;
                            }
                            document = res.data.document || document || {};
                            filesToSend.splice(0, 1);
                            filesToSend.forEach(function (file) {
                                promises.push(uploadFiles(file));
                            });
                            if (!check) {
                                $q.all(promises)
                                    .then(function (res) {
                                        candidateDocAction(res)
                                            .then(function (res) {
                                                    defer.resolve(res);
                                                },
                                                function (err) {
                                                    defer.reject(err);
                                                });
                                    }, function (err) {
                                        defer.reject(err);
                                    });
                            } else {
                                defer.resolve();
                            }
                        }
                    });
            },
            function (error) {
                defer.reject(error);
            });
        return defer.promise;
    }
    self.showBritPassport = function () {
        if (!hUser.isEmployer() && isCandidate) {
            if (self.rtwRemoteCheckingEnabled) {
                self.rtwRemoteCheckingSection = true;
                self.adjustFlags();
            }
        }
        if (!self.rtwRemoteCheckingEnabled) {
            self.BritishPassportFlag = true;
            self.LastSectionFlag = false;
            self.mainOptionsFlag = false;
            self.syncScope();
        }

    }
    self.showOthers = function () {
        self.OthersFlag = true;
        self.LastSectionFlag = false
        self.mainOptionsFlag = false;
        self.rtwRemoteCheckingSection = false;
    }
    self.backToPrevious = function () {
        self.mainOptionsFlag = true;
        self.LastSectionFlag = true;
        self.BritishPassportFlag = false;
        self.OthersFlag = false;
        self.shareCodeFlag = false;
        self.rtwRemoteCheckingSection = false;
        self.selectedFiles = {};
        self.uploadFormAttachments = {};
        self.share_code_option = null;
    }
    self.adjustFlags = function () {
        self.shareCodeFlag = false;
        self.BritishPassportFlag = false;
        self.mainOptionsFlag = false;
        self.LastSectionFlag = false;
    }
    self.adjustShareCodeFlags = function () {
        self.data.shareCodeFlag = true;
        self.data.LastSectionFlag = true;
        self.data.mainOptionsFlag = false;
    }
    self.adjustBritishPassportFlags = function () {
        self.data.BritishPassportFlag = true;
        self.data.LastSectionFlag = false;
        self.data.mainOptionsFlag = false;
    }

    self.requestAPI = function () {
        var defer = $q.defer();
        EVerifyAPI.startUserCaseTrustId(self.brandId, self.userId, self.jobId, true)
            .then(function (Data) {
                self.link_to_trustid = Data['guest_link_url'];
                window.location= self.link_to_trustid;
                defer.resolve();
            }).catch(function (err) {
            console.error(err);
            defer.reject();
        });

    }
    self.save = function (saveData) {
        var defer = $q.defer();

        saveData = saveData || {};
        if (self.share_code_option === self.identityOptions.SHARE_CODE) {
            if (hUser.isEmployer() && !self.isCandidate) {
                if(self.checkShareCodeDoc()){
                    self.getFiles().then(function (files) {
                            var requestedFiles = {};

                            files.forEach(function (file) {
                                requestedFiles[file.list] = requestedFiles[file.list] || {};
                                requestedFiles[file.list].attachment_file = requestedFiles[file.list].attachment_file || [];
                                requestedFiles[file.list].attachment_code_lookup_ids = requestedFiles[file.list].attachment_code_lookup_ids || [];
                                requestedFiles[file.list].attachment_expiration_dates = requestedFiles[file.list].attachment_expiration_dates || [];

                                requestedFiles[file.list].attachment_file.push(file.file);
                                requestedFiles[file.list].attachment_code_lookup_ids.push(file.code);
                                if (file.expiration_date) {
                                    requestedFiles[file.list].attachment_expiration_dates.push(file.expiration_date);
                                }

                                requestedFiles[file.list].custom_name = file.name;
                                requestedFiles[file.list].list_type = file.list;
                            });

                            var keys = Object.keys(requestedFiles);
                            var filesToSend = [];

                            keys.forEach(function (key) {
                                var file = requestedFiles[key];

                                if (file) {
                                    file['document_code'] = OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT;
                                    file['birth_date'] = moment(self.data.birth_date).format('YYYY-MM-DD');
                                    file['share_code'] = self.data.share_code;

                                    if (saveData.positionId) {
                                        file['position_id'] = saveData.positionId;
                                    }

                                    if (saveData.userId) {
                                        file['user_id'] = saveData.userId;
                                    }

                                    if (saveData.jobId) {
                                        file['job_id'] = saveData.jobId;
                                    }

                                    if (saveData.applicationId) {
                                        file['application_id'] = saveData.applicationId;
                                    }

                                    if (saveData.prospectId) {
                                        file['prospect_id'] = saveData.prospectId;
                                    }

                                    filesToSend.push(file);
                                }
                            });

                            uploadFiles(filesToSend[0])
                                .then(function (res) {
                                    if (res && res.data && (res.data.document || res.data.attachments)) {

                                        defer.resolve();
                                    }
                                });
                        },
                        function (error) {
                            defer.reject(error);
                        });
                }
                else {
                    var data = {};
                    data['document_code'] = OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT;
                    data['birth_date'] = moment(self.data.birth_date).format('YYYY-MM-DD');
                    data['share_code'] = self.data.share_code;
                    if (saveData.positionId) {
                        data['position_id'] = saveData.positionId;
                    }
                    if (saveData.userId) {
                        data['user_id'] = saveData.userId;
                    }
                    if (saveData.jobId) {
                        data['job_id'] = saveData.jobId;
                    }
                    if (saveData.applicationId) {
                        data['application_id'] = saveData.applicationId;
                    }
                    if (saveData.prospectId) {
                        data['prospect_id'] = saveData.prospectId;
                    }
                    return uploadFiles(data);
                }
            }
            else {
                if (self.checkShareCodeDoc()) {
                    self.getFilesProcess(saveData).then(function(res){
                        defer.resolve(res)
                    },function (error) {
                        defer.reject(error);
                    });
                }
                else {
                    return candidateDocAction()
                }
            }
        } else
        {
            self.getFilesProcess(saveData).then(function(res){
                defer.resolve(res)
            },function (error) {
                defer.reject(error);
            });
        }

        return defer.promise;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);
        switch (rule.name) {

            case "requiredIfFile":
                if (self.share_code_option !== self.identityOptions.SHARE_CODE) {
                    var listId = rule.params[0].trim();
                    if (self.uploadDocs) {
                        if (!self.upload['doc_list_' + listId] && self.selectedFiles[listId]) {
                            self.validator.validation[name].errors[rule.name] = true;
                            return false;
                        }
                    } else {
                        if (self.countryType === RightToWorkAPI.COUNTRY_TYPES.GENERIC
                            || self.countryType === RightToWorkAPI.COUNTRY_TYPES.ROI) {
                            if (!self.selectedFiles[listId]) {
                                return false;
                            }
                        } else if (listId === "all") {
                            if (!self.selectedFiles['A'] && !self.selectedFiles['B'] && !self.selectedFiles['C'] && !self.selectedFiles['PASSPORT']) {
                                return false;
                            }
                        }
                    }
                }
                break;

            case "requiredIfShareCode":
                if (self.share_code_option === self.identityOptions.SHARE_CODE) {
                    if (!value) {
                        return false;
                    }
                }
                break;
        }

        return true;
    };
};
